<!-- @format -->

@if (selectErrorList$ | async; as errors) {
  @if (errors[attributeName()]) {
    <div
      class="hmf-display-flex hmf-mb-xs hmf-mb-md-s">
      <span
        class="label-negative hmf-header-bold-xs hmf-text-transform-none">
        <homefield-icon
          class="error-msg-icon"
          width="24px"
          height="14px"
          fill="var(--hmf-label-negative)"
        name="alert-info-filled"></homefield-icon>
        {{ errors[attributeName()] }}
      </span>
    </div>
  }
}
<hmf-selector
  id="size-panel-button"
  [contained]="true"
  [selector]="'rectangular'"
  [width]="'100%'"
  [ariaLabel]="'Open ' + attributeName().toLowerCase() + ' panel'"
  (keydown.enter)="openDrawer()"
  (keydown.space)="openDrawer()"
  (click)="openDrawer()">
  <div
    ngProjectAs="rectangularSelectorBody"
    class="hmf-display-flex hmf-align-items-center hmf-justify-content-between">
    <div class="size-display-value hmf-m-xxs hmf-display-flex hmf-align-items-center">
      @if (selectedSize$ | async; as selectedSize) {
        <span class="hmf-header-xs hmf-mr-xxxs label-base">{{
          attributeName()
        }}</span>
        <span class="hmf-header-bold-xs label-base"> {{ selectedSize?.value }}</span>
      } @else {
        <span class="hmf-header-xs hmf-mr-xxxs label-base"
          >Select {{ attributeName() }}</span
          >
        }
      </div>
      <div class="hmf-display-flex hmf-align-items-center">
        @if (selectedSize$ | async; as selectedSize) {
          <span>
            @if (
              !(selectDisabledAttributes$ | async)[selectedSize?.name]?.includes(
              selectedSize?.value
              )
              ) {
              <span
                class="hmf-body-s label-disabled"
                >Not Available
              </span>
            }
          </span>
        }
        <homefield-icon
          width="22px"
          height="22px"
          alt="arrow right"
          name="chevron-right"
          class="hmf-mr-xxs">
        </homefield-icon>
      </div>
    </div>
  </hmf-selector>

  <hmf-drawer
    id="size-selection-panel"
    [interactability]="false"
    [direction]="drawerDirection()"
    (closed)="checkAttributeErrorsOnClose()">
    <div class="hmf-display-flex hmf-flex-column selection-panel-content-wrapper">
      <div class="hmf-pl-s hmf-pr-m">
        @if (selectErrorList$ | async; as errorList) {
          @if (attributeName() && errorList[attributeName()]) {
            <h2 class="hmf-header-bold-s hmf-p-m hmf-text-align-center label-negative">
              <homefield-icon
                fill="var(--hmf-label-negative)"
                width="24px"
                height="14px"
              name="alert-info-filled"></homefield-icon>
              Please Select {{ attributeName() }}
            </h2>
          }
        } @else {
          <h2 class="hmf-header-bold-s hmf-p-m hmf-text-align-center">
            Select {{ attributeName() || 'Size' }}
          </h2>
        }
      </div>
      <div class="hmf-pl-s hmf-pr-m overflow-auto">
        @for (attributesOption of sizeAttributeData(); track trackByAttributeValue(attributesOption)) {
          <hmf-selector
            id="color-option"
            class="hmf-mb-xs"
					[unavailable]="
						!(selectDisabledAttributes$ | async)[attributesOption.name].includes(
							attributesOption.value
						)
					"
            [contained]="false"
            [selector]="'rectangular'"
            [circleVariant]="false"
            [dblBorder]="false"
            [width]="'100%'"
            [selected]="attributesOption.value === (selectedSize$ | async)?.value"
            [ariaLabel]="attributesOption.value"
            (keydown.enter)="selectedAttribute(attributesOption)"
            (keydown.space)="selectedAttribute(attributesOption)"
            (click)="selectedAttribute(attributesOption)">
            <div
              ngProjectAs="rectangularSelectorBody"
              class="hmf-display-flex hmf-justify-content-between">
              <div
                class="hmf-display-flex hmf-align-items-center hmf-pl-xs hmf-pl-m-s hmf-py-xs hmf-py-m-s">
                <span
                  class="hmf-text-transform-none hmf-body-m-l hmf-body-m hmf-ml-xs hmf-text-align-left label-base"
								[ngClass]="{
									'hmf-body-bold-m-l hmf-body-bold-m':
										attributesOption.value === (selectedSize$ | async)?.value
								}"
                  >{{ attributesOption.value }}</span
                  >
                </div>
                @let price = priceSizeMap()().get(attributesOption.value);
                @if (price) {
                  <ng-container>
                    @if (!price.emptyPrice) {
                      <div
                        class="hmf-body-m-l hmf-body-m hmf-display-flex hmf-align-items-center hmf-mr-xs label-base"
									[ngClass]="{
										'label-sale':
											price.minOfferPrice < price.minListPrice ||
											price.minOfferPrice?.toString().includes('.97')
									}">
                        {{ price.minOfferPrice | currency }}
                        @if (price.maxOfferPrice > price.minOfferPrice) {
                          <span
                            class="hmf-pl-xxxs price-range label-base"
										[ngClass]="{
											'label-sale':
												price.minOfferPrice < price.minListPrice ||
												price.minOfferPrice?.toString().includes('.97')
										}">
                            - {{ price.maxOfferPrice | currency }}</span
                            >
                          }
                        </div>
                      }
                      @if (price.emptyPrice) {
                        <div
                          class="hmf-body-m-l hmf-body-m hmf-display-flex hmf-align-items-center hmf-mr-xs label-base">
                          See Price In Cart
                        </div>
                      }
                    </ng-container>
                  }
                </div>
              </hmf-selector>
            }
          </div>
        </div>
      </hmf-drawer>
